export const Config = {

  instance: null,

  load () {
    let config = localStorage.getItem('asf-config');
    if (config !== null) {
      this.instance = JSON.parse(config);
    }
    if (this.instance === null || typeof this.instance !== 'object') {
      this.instance = {};
      this.save();
    }
  },

  save () {
    localStorage.setItem('asf-config', JSON.stringify(this.instance));
  },

  get (area, property) {
    if (this.instance === null) {
      this.load();
    }
    if (this.instance[area] === null || this.instance[area] === undefined) {
      this.instance[area] = {};
    }
    if (this.instance[area][property] === null || this.instance[area][property] === undefined) {
      this.instance[area][property] = null;
    }
    return this.instance[area][property];
  },

  set (area, property, value) {
    if (this.instance === null) {
      this.load();
    }
    if (this.instance[area] === null || this.instance[area] === undefined) {
      this.instance[area] = {};
    }
    if (this.instance[area][property] === null || this.instance[area][property] === undefined) {
      this.instance[area][property] = null;
    }
    this.instance[area][property] = value;
    this.save();
    return value;
  },

  unset (area, property) {
    if (this.instance[area][property] !== null && this.instance[area][property] !== undefined) {
      delete this.instance[area][property];
    }
    this.save();
  },

  purge () {
    localStorage.removeItem('asf-config');
  }

};